import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-cancel-error-modal',
  templateUrl: './error-modal.component.pug',
  styleUrls: ['./error-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class ErrorModalContentComponent implements OnInit {
  negateResult = false;
  title = $localize`Leave this page?`
  message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
  icon = "https://assets.xref.com/omni/shared/error_icon.svg";
  showErrorIcon = true


  constructor(
    private bsModalRef: BsModalRef, 

  ) {
  }

  ngOnInit(): void { }




  close() {
    this.bsModalRef.hide();
  }
}
